var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-td4-box",class:{'td4-body-bg':_vm.tdType == 'body'},style:('width:' + _vm.boxWidth),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{ref:"td",staticClass:"my-td4-box-inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }